// 持久化 Device-Id：每个浏览器（每个 localStorage 域）一个稳定 UUID。
//
// Android 用的是设备的硬件 imei/oaid，Web 没这个能力，只能拿一个本地生成的 UUID
// 当稳定标识。清浏览器数据会重置（行为类似新设备，符合后端预期）。

const STORAGE_KEY = "jzbro_device_id";

function uuidv4(): string {
  // crypto.randomUUID 仅在 secure context 可用（HTTPS / localhost）。
  // 非安全上下文回落到 random hex 拼装，质量足够当 device-id。
  if (typeof crypto !== "undefined" && "randomUUID" in crypto) {
    return crypto.randomUUID();
  }
  const hex = "0123456789abcdef";
  const rand = (n: number) =>
    Array.from({ length: n }, () => hex[Math.floor(Math.random() * 16)]).join("");
  // 8-4-4-4-12，第 13 位强制 4（v4 标识），第 17 位强制 8/9/a/b
  const y = ["8", "9", "a", "b"][Math.floor(Math.random() * 4)];
  return `${rand(8)}-${rand(4)}-4${rand(3)}-${y}${rand(3)}-${rand(12)}`;
}

export function getDeviceId(): string {
  let id = localStorage.getItem(STORAGE_KEY);
  if (!id) {
    id = uuidv4();
    localStorage.setItem(STORAGE_KEY, id);
  }
  return id;
}

/** 重新生成 Device-Id 并持久化。
 *  用于"重置游客身份"：换 ID 让后端把当前会话当成全新设备。 */
export function regenerateDeviceId(): string {
  const id = uuidv4();
  localStorage.setItem(STORAGE_KEY, id);
  return id;
}
